import { render, staticRenderFns } from "./UnifiedMarket.vue?vue&type=template&id=c1712c50&scoped=true"
import script from "./UnifiedMarket.vue?vue&type=script&lang=js"
export * from "./UnifiedMarket.vue?vue&type=script&lang=js"
import style0 from "./UnifiedMarket.vue?vue&type=style&index=0&id=c1712c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1712c50",
  null
  
)

export default component.exports